module.exports = __webpack_public_path__ + "img/arrow-down.fb541647.svg";